import swal from "sweetalert2";
import createSpinner from "../../../../Shared/Functions/createSpinner";
import { customAutoCompleteFilter, standardGridPageSize } from "../../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($scope, connectionsDataService, helperService, FileSaver) {
    const vm = this;

    vm.$onInit = init;
    vm.$onChanges = saveForm;
    vm.click = click;
    vm.helperService = helperService;
    vm.setSourceMetadataDropdownOptions = setSourceMetadataDropdownOptions;
    vm.itemSelectionChanged = itemSelectionChanged;
    vm.exportDataMappings = exportDataMappings;
    vm.importDataMappings = importDataMappings;

    const mappingKeys = ['dataMappingsValid'];
    vm.importTriggered = false;

    $scope.$on("ImportCustomProductDataMappings", (event, args) => getMappingsAfterImport());

    vm.sourceTypes = [
        { Id: 2, Name: "Literal" },
        { Id: 1, Name: "Metadata" }
    ];

    vm.loopReferenceFieldOptions = [
        { Id: 1, Name: "Yes", Value: true }
    ];

    vm.allRequiredFields = [];
    vm.filteredDataMappings = [];

    async function init() {
        vm.loading = true;

        vm.sourceEntityList = vm.product.CustomProductSourceMetadata.Entities.map(entity => { return { EntityName: entity.EntityName, Id: entity.Id } });
        vm.sourceEntityList.unshift({ EntityName: '-- Select a Source Entity --', Id: -1 });

        if (vm.product.mappingsMetadata) {
            vm.targetMetadata = vm.product.mappingsMetadata;
            vm.currentTabIndex = vm.targetMetadata.Entities.findIndex(entity => entity.active);

            vm.targetMetadata.Entities.forEach(entity => {
                if (vm.product.ObjectLevelDataAnalysisEnabled && entity.SupportsObjectLevel) {
                    entity.hidden = false;
                } else if (!vm.product.ObjectLevelDataAnalysisEnabled && entity.SupportsObjectLevel) {
                    entity.hidden = true;
                }
            });
        } else {
            await getTargetMetadata();
        }

        await getMetadataGrid();
        await setSourceMetadataDropdownOptions(false);

        vm.loading = false;
    }

    async function exportDataMappings() {
        vm.exportPending = new createSpinner();
        try {
            const res = await connectionsDataService.exportMappings(vm.product.ID);
            FileSaver.saveAs(res.data, vm.product.Name + '_DataMappings.xlsx');
            vm.exportPending.loadingValue = false;
        } catch (err) {
            vm.exportPending.loadingValue = false;
        }
    }

    async function importDataMappings(file) {
        vm.importPending = new createSpinner();
        try {
            await swal(helperService.areYouSureParams('Import Data Mappings', 'Are you sure you want to import? This will remove your existing mappings and automatically save the imported mappings.', 'Import'));

            vm.importPending.loadingValue = true;
            vm.importTriggered = true;
            let formData = new FormData();

            formData.append(file.file.name, file.file);

            await connectionsDataService.importMappings(vm.product.ID, formData);

            vm.mappingsFile.files = [];

            vm.importPending.loadingValue = false;
        } catch (err) {
            vm.importPending.loadingValue = false;
        }
    }

    async function getMappingsAfterImport() {
        if (vm.importTriggered) {
            let response = await connectionsDataService.getDataMappingsByProductId(vm.product.ID);

            vm.product.DataMappings = response.data;
            clearExistingMappings();
            configureExistingMappings();

            vm.metadataGridDataSource.read();
        }
    }

    function itemSelectionChanged(dataItem) {
        let map = {};

        map.TargetMetadataFieldId = dataItem.Id;
        map.SourceMetadataFieldId = dataItem.sourceType.Id === 1 && dataItem.sourceField?.Id !== -1 ? dataItem.sourceField.Id : null;
        map.OverrideValue = dataItem.sourceType.Id === 2 ? dataItem.sourceField : null;

        if (dataItem.sourceType.Id === 3) {
            map.UseLoopReferenceField = true;
        }

        if (vm.product.DataMappings.length && vm.product.DataMappings.any(mapping => mapping.TargetMetadataFieldId === map.TargetMetadataFieldId)) {
            let existingItemIndex = vm.product.DataMappings.findIndex(mapping => mapping.TargetMetadataFieldId === map.TargetMetadataFieldId);

            vm.product.DataMappings[existingItemIndex] = map;
        } else {
            vm.product.DataMappings.push(map);
        }

        if (dataItem.sourceField?.Id === -1) {
            let mappingModelIndex = vm.targetMetadata.Entities[vm.currentTabIndex].Fields.findIndex(mapping => mapping.TargetMetadataFieldId === dataItem.Id);

            dataItem.sourceField = null;
            vm.targetMetadata.Entities[vm.currentTabIndex].Fields[mappingModelIndex].sourceField = null;

        }
 

        if (dataItem.sourceType.Id === 3) {
            dataItem.sourceField = vm.loopReferenceFieldOptions[0];
        }

        // filter object out of Data Mappings array if both values are null
        vm.product.DataMappings = vm.product.DataMappings.filter(mapping => mapping.SourceMetadataFieldId !== null || (mapping.OverrideValue !== null && mapping.OverrideValue !== '') || mapping.UseLoopReferenceField);

        vm.targetMetadata.Entities[vm.currentTabIndex].Fields = vm.metadataGridDataSource._data;
        vm.product.mappingsMetadata = vm.targetMetadata;

        validateDataMappings();
    }

    async function getTargetMetadata() {
        try {
            let { data } = await connectionsDataService.getUpiTargetMetadata(vm.product.ID, vm.product.CustomProductMappingType);
            vm.targetMetadata = data;
            vm.targetMetadata.Entities.forEach(entity => {
                entity.sourceEntity = vm.sourceEntityList[0];

                if (vm.targetMetadata.Entities.findIndex(e => e.Id === entity.Id) === 0) {
                    entity.active = true;
                    entity.hidden = false;
                } else {
                    entity.active = false;
                }

                if (!vm.product.ObjectLevelDataAnalysisEnabled && entity.SupportsObjectLevel) {
                    entity.hidden = true;
                }

                let filteredFields = vm.product.DataMappings.filter(item => (item.TargetEntityId === entity.Id) && !entity.hidden);

                vm.filteredDataMappings = vm.filteredDataMappings.concat(filteredFields);
            });

            vm.currentTabIndex = vm.targetMetadata.Entities.findIndex(entity => entity.active);
            vm.product.DataMappings = vm.filteredDataMappings;

            if (vm.product.DataMappings.length) {
                await configureExistingMappings();
            } else {
                vm.targetMetadata.Entities[vm.currentTabIndex].Fields.forEach(field => {
                    field.sourceType = { Id: 1, Name: "Metadata" };
                    field.sourceField = null;
                });
            }

            vm.product.mappingsMetadata = vm.targetMetadata;
        } catch {
            vm.loading = false;
        }
    }

    async function configureExistingMappings() {
        vm.uniqueEntityMappings = vm.product.DataMappings.reduce((unique, item) => {
            if (!unique.some(obj => obj.TargetEntityId === item.TargetEntityId) && !item.OverrideValue && !item.UseLoopReferenceField) {
                unique.push(item);
            }

            return unique;
        }, []);

        vm.product.DataMappings.forEach(mapping => {
            vm.targetMetadata.Entities.forEach(entity => {
                vm.uniqueEntityMappings.forEach(uniqueMapping => {
                    if (uniqueMapping.TargetEntityId === entity.Id) {
                        entity.sourceEntity = { Id: uniqueMapping.SourceEntityId, EntityName: uniqueMapping.SourceEntityName };
                    }
                });

                entity.Fields.forEach(field => {
                    if (field.Id === mapping.TargetEntityFieldId) {
                        if (mapping?.SourceEntityFieldId) {
                            field.sourceType = { Id: 1, Name: "Metadata" };
                            field.sourceField = { Id: mapping.SourceEntityFieldId, FieldName: mapping.SourceEntityFieldName };
                        } else if (mapping.OverrideValue) {
                            field.sourceType = { Id: 2, Name: "Literal" };
                            field.sourceField = mapping.OverrideValue;
                        } else if (mapping.UseLoopReferenceField) {
                            field.sourceType = { Id: 3, Name: "Use Loop Reference Field" };
                            field.sourceField = vm.loopReferenceFieldOptions[0];
                        } else if (!mapping?.sourceField) {
                            field.sourceType = { Id: 1, Name: "Metadata" };
                            field.sourceField = null;
                        }
                    }
                });
            });
        });

        if (vm.targetMetadata.Entities.some(entity => entity.sourceEntity.Id !== -1)) {
            vm.targetMetadata.Entities[vm.currentTabIndex].active = false;
            vm.currentTabIndex = vm.targetMetadata.Entities.findIndex(e => e.sourceEntity.Id !== -1);
            vm.targetMetadata.Entities[vm.currentTabIndex].active = true;
        }

        vm.product.DataMappings = vm.product.DataMappings.map(item => {
            let data = {};
            if (item.SourceMetadataFieldId !== null || item.OverrideValue !== null) {
                data.TargetMetadataFieldId = item.TargetEntityFieldId;
                data.SourceMetadataFieldId = item.SourceEntityFieldId === 0 ? null : item.SourceEntityFieldId;
                data.OverrideValue = item.OverrideValue;
            }

            if (item.UseLoopReferenceField) {
                data.UseLoopReferenceField = item.UseLoopReferenceField;
            }

            return data;
        });

        await validateDataMappings();
    }
    function setSourceMetadataDropdownOptions(sourceEntityChanged) {
        if (vm.targetMetadata.Entities[vm.currentTabIndex]?.sourceEntity.Id !== -1) {
            let selectedSourceEntity = vm.product.CustomProductSourceMetadata.Entities.find(source => source.EntityName === vm.targetMetadata.Entities[vm.currentTabIndex].sourceEntity.EntityName);

            vm.sourceMetadataFields = selectedSourceEntity?.EntityFields ? selectedSourceEntity.EntityFields : [];
            if (vm.sourceMetadataFields[0].Id !== -1) {
                vm.sourceMetadataFields.unshift({ Id: -1, FieldName: '-- Select a Source Field --' });
            }

            if (selectedSourceEntity.Parameterized) {
                vm.sourceTypes.push({ Id: 3, Name: "Use Loop Reference Field" });
            }
        } else {
            vm.sourceMetadataFields = [];
            clearExistingMappings();
        }

        vm.targetMetadata.Entities[vm.currentTabIndex].Fields.forEach(field => {
            field.sourceType = !field?.sourceType ? { Id: 1, Name: "Metadata" } : field.sourceType;
            field.sourceType = field.UseLoopReferenceField ? { Id: 3, Name: "Use Loop Reference Field" } : field.sourceType;
            if (sourceEntityChanged) {
                field.sourceType = { Id: 1, Name: "Metadata" };
                field.sourceField = null;
                vm.product.DataMappings.forEach(mapping => {
                    if (mapping.TargetMetadataFieldId === field.Id) {
                        mapping.SourceMetadataFieldId = null;
                        mapping.OverrideValue = null;
                        mapping.UseLoopReferenceField = false;
                    }
                });
            }
        });

        vm.metadataGridDataSource.read();

        defineRequiredFields();

        vm.sourceTypeOptions = {
            dataSource: vm.sourceTypes,
            dataTextField: "Name",
            dataValueField: "Id"
        };
    }

    function clearExistingMappings() {
        vm.targetMetadata.Entities[vm.currentTabIndex].Fields.forEach(field => {
            vm.product.DataMappings = vm.product.DataMappings.filter(mapping => mapping.TargetMetadataFieldId !== field.Id);
        });
    }

    function defineRequiredFields() {
        vm.targetMetadata.Entities.forEach(entity => {
            let requiredFields = entity.Fields.filter(field => field.IsRequired);

            if (!entity.hidden && entity.sourceEntity.Id !== -1) {
                vm.allRequiredFields = vm.allRequiredFields.concat(requiredFields).unique();
            } else if (entity.sourceEntity.Id === -1) {
                requiredFields.forEach(rf => {
                    vm.allRequiredFields = vm.allRequiredFields.filter(field => field.Id !== rf.Id);
                });
            }

            vm.allRequiredFieldIds = vm.allRequiredFields.map(field => field.Id);
        });

        validateDataMappings();
    }

    function getMetadataGrid() {
        vm.metadataColumns = [
            { title: "Target Field", field: "FieldLabel", template: `<label>{{dataItem.FieldLabel}}: </label> <span>{{dataItem.DataType}}</span> <span ng-if="dataItem.IsRequired" class="error-req">*</span>`, filterable: customAutoCompleteFilter, width: 50 },
            { title: "Maps to:", template: `<div style="text-align: center;"><span class="fa fa-lg fa-arrow-right flex-center"></span></div>`, width: 50 },
            { title: "Source Type", template: `<select kendo-drop-down-list
                            k-options="dmvm.sourceTypeOptions"
                            k-ng-model="dataItem.sourceType"
                            k-on-change="dataItem.sourceField = null; dmvm.itemSelectionChanged(dataItem);"
                            style="width:100%"></select>`, width: 50
            },
            { title: "Source Field", template: `<div ng-if="dataItem.sourceType.Name === 'Literal'" class="form-group text-color m-r-sm"><input type="text" style="width:100%" class="source-field-input" ng-model="dataItem.sourceField" ng-change="dmvm.itemSelectionChanged(dataItem)" />
                            </div><div ng-if="dataItem.sourceType.Name !== 'Literal' && dataItem.sourceType.Id !== 3"><oi-select
                            ng-disabled="!dmvm.product.CustomProductSourceMetadata"
                            oi-options="sourceField.FieldName for sourceField in dmvm.sourceMetadataFields | orderBy: ['FieldName'] track by sourceField.Id"
                            ng-change="dmvm.itemSelectionChanged(dataItem)"
                            ng-model="dataItem.sourceField"
                            placeholder="-- Select a Source Field --"
                            style="width:100%;"></oi-select>
                        </div><div ng-if="dataItem.sourceType.Id === 3"><oi-select
                            ng-disabled="!dmvm.product.CustomProductSourceMetadata"
                            oi-options="sourceField.Name for sourceField in dmvm.loopReferenceFieldOptions | orderBy: ['Name'] track by sourceField.Id"
                            ng-change="dmvm.itemSelectionChanged(dataItem)"
                            ng-model="dataItem.sourceField"
                            style="width:100%;"></oi-select>
                        </div>`,
                width: 100
            }
        ];

        vm.metadataGridOptions = helperService.setMainGridOptions(vm.metadataColumns, 500);
        vm.metadataGridOptions.autoBind = true;
        vm.metadataGridOptions.noRecords = {
            template: "<div class='no-data-to-display-message'>No items to display</div>"
        };

        vm.metadataGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async options => {
                    try {
                        let data = vm.targetMetadata.Entities[vm.currentTabIndex]?.sourceEntity.Id !== -1 ? vm.targetMetadata.Entities[vm.currentTabIndex].Fields : [];
                        options.success(data);
                    } catch {
                        options.error();
                    }
                }
            }
        });
    }

    async function click(tab) {
        const tabIndex = vm.targetMetadata.Entities.findIndex(t => t.Id === tab.Id);

        if (vm.currentTabIndex !== tabIndex) {
            vm.targetMetadata.Entities[vm.currentTabIndex].active = false;
            vm.currentTabIndex = tabIndex;
            vm.targetMetadata.Entities[vm.currentTabIndex].active = true;
        }

        await setSourceMetadataDropdownOptions(false);
        vm.metadataGridDataSource.read();
    }

    function validateDataMappings() {
        let validity = vm.allRequiredFieldIds.every(id => validity = vm.product.DataMappings.find(mapping => id === mapping.TargetMetadataFieldId));

        if (validity) {
            vm.product.dataMappingsValid = true;
        } else {
            vm.product.dataMappingsValid = null;
        }
    }

    async function saveForm() {
        vm.saving = true;
        if (vm.allRequiredFieldIds) {
            await validateDataMappings();
        }

        const product = vm.product,
            keys = mappingKeys;

        vm.saveStep(product, keys);
        vm.saving = false;
    }
}